import '../style/pagination-bs2tOXcL.css'
import { defineComponent as $, useModel as N, toRefs as P, computed as s, openBlock as E, createElementBlock as I, normalizeClass as M, unref as i, createElementVNode as k, toDisplayString as y, createVNode as p, mergeProps as c } from "vue";
import { SIZE_MAP as u } from "./constant/icon-button.js";
import "x-utils";
import "@vueuse/core";
import "lodash-es";
import { useI18n as B } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import m from "./icon-button.js";
import { useComponentClassList as x } from "./hooks/useComponentClassList.js";
const A = { class: "e-pagination__info" }, d = "e-pagination", Q = /* @__PURE__ */ $({
  name: d,
  __name: "pagination",
  props: {
    page: { default: 1 },
    pageSize: { default: 10 },
    total: {},
    hasNext: { type: Boolean, default: !0 },
    size: { default: "md" },
    disabled: { type: Boolean }
  },
  emits: ["change", "update:page"],
  setup(g, { emit: f }) {
    const e = g, a = N(e, "page", { local: !0 }), v = f, { t: b } = B(), { size: h } = P(e), z = x(d, {
      size: h
    }), l = s(() => {
      switch (e.size) {
        case "sm":
          return u.sm;
        case "lg":
          return u.lg;
        default:
          return {
            iconSize: 20,
            buttonSize: 32
          };
      }
    }), _ = s(() => {
      const t = a.value, o = `${(t - 1) * e.pageSize + 1}`, n = t * e.pageSize;
      if (e.total) {
        const S = `${o}-${n > e.total ? e.total : n}`;
        return b("pagination.info", { current: S, total: e.total });
      }
      return `${o}-${n}`;
    }), C = s(() => e.total ? Math.ceil(e.total / e.pageSize) : 1 / 0);
    function r(t) {
      const o = a.value + t;
      a.value = o, v("change", a.value);
    }
    return (t, o) => (E(), I("div", {
      class: M(i(z))
    }, [
      k("span", A, y(_.value), 1),
      p(i(m), c({
        icon: "chevron-left",
        disabled: i(a) <= 1 || t.disabled,
        "aria-label": "previous page",
        class: "e-pagination__button",
        circle: "",
        "hover-scale": ""
      }, l.value, {
        onClick: o[0] || (o[0] = (n) => r(-1))
      }), null, 16, ["disabled"]),
      p(i(m), c({ icon: "chevron-right" }, l.value, {
        disabled: i(a) >= C.value || !t.hasNext || t.total === 0 || t.disabled,
        circle: "",
        "hover-scale": "",
        "aria-label": "next page",
        class: "e-pagination__button",
        onClick: o[1] || (o[1] = (n) => r(1))
      }), null, 16, ["disabled"])
    ], 2));
  }
});
export {
  Q as default
};
//# sourceMappingURL=pagination.js.map
